import { defineFetch } from 'resift';

const makeGetDefaultPersonSettings = defineFetch({
  displayName: 'Get default person settings',
  make: () => ({
    request: () => ({ http }) =>
      http({
        method: 'GET',
        route: `/default-settings/person`,
      }),
  }),
});

const getDefaultPersonSettings = makeGetDefaultPersonSettings();

export default getDefaultPersonSettings;
